const Healthinstructions = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <clipPath id="a">
          <rect
            width="18"
            height="18"
            transform="translate(-0.203)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(636 -4522)">
        <g transform="translate(-635.797 4522)">
          <g transform="translate(-0.203)">
            <path
              d="M144.764,14.355h1.626a1.081,1.081,0,0,0,1.08-1.08V10.425h2.849a1.081,1.081,0,0,0,1.08-1.08V7.719a1.081,1.081,0,0,0-1.08-1.08H147.47V3.79a1.081,1.081,0,0,0-1.08-1.08h-1.626a1.081,1.081,0,0,0-1.08,1.08V6.639h-2.849a1.081,1.081,0,0,0-1.08,1.08V9.345a1.081,1.081,0,0,0,1.08,1.08h2.849v2.849a1.081,1.081,0,0,0,1.08,1.08Zm-3.933-5.009,0-1.63h3.116a.81.81,0,0,0,.809-.809l0-3.12,1.63,0V6.906a.81.81,0,0,0,.809.809h3.116l0,0,0,1.63H147.2a.81.81,0,0,0-.809.809l0,3.121-1.63,0V10.158a.81.81,0,0,0-.809-.809Zm12.325,3.1a.538.538,0,1,0-.955-.5,7.415,7.415,0,1,1,.737-2.23A.538.538,0,0,0,154,9.9a8.54,8.54,0,1,0-.845,2.554Z"
              transform="translate(-137.045)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Healthinstructions;
